module.exports = __webpack_public_path__ + "c26c15a2521f45a044a884b13f8ca360.svg";